module.exports = __webpack_public_path__ + "static/6-2a80f3c870b4c7b40b7cb4afb9a13818.jpg";